var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWorkspaceStudio = function SvgWorkspaceStudio(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    transform: "translate(.7 .294)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M1.3 0a1.3 1.3 0 0 1 1.3 1.3v19.573h24.233a1.3 1.3 0 0 1 1.294 1.168l.006.133a1.3 1.3 0 0 1-1.3 1.3H1.3a1.3 1.3 0 0 1-1.3-1.3V1.3A1.3 1.3 0 0 1 1.3 0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.3,
    cy: 14.706,
    r: 2,
    opacity: 0.191
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.8,
    cy: 8.206,
    r: 2.5,
    opacity: 0.38
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.8,
    cy: 7.206,
    r: 3.5,
    opacity: 0.494
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.3,
    cy: 15.706,
    r: 3,
    opacity: 0.439
  }))));
};
export default SvgWorkspaceStudio;